$(document).ready(() => {
  $('.home-banner__slider').slick({
    rtl:true,
    prevArrow: $('.home-banner__arrows-right'),
    nextArrow: $('.home-banner__arrows-left'),
  })
})


// --- Mobile menu: 1st click opens, 2nd click navigates ---
document.addEventListener('click', function (e) {
  // נתפוס רק כותרות של הורים בתפריט המובייל
  const link = e.target.closest('#responsiveMenu li.parent-level.parent.has-dropdown > a.parent');
  if (!link) return;
  if (window.innerWidth > 1024) return; // מובייל בלבד

  const li = link.closest('li.parent-level.parent.has-dropdown');
  const submenu = li.querySelector(':scope > ul.parent-level-ul');

  // לחיצה ראשונה — לפתוח במקום לנווט
  if (!link.dataset.openedOnce) {
    e.preventDefault();
    e.stopImmediatePropagation();

    // פותחים כמו בפלוס
    li.classList.add('open');
    link.setAttribute('aria-expanded', 'true');
    if (submenu) submenu.style.maxHeight = submenu.scrollHeight + 'px';

    // אם פותחים פריט אחר – ננקה את הסימון באחרים
    document.querySelectorAll('#responsiveMenu li.parent-level.parent.has-dropdown > a.parent[data-opened-once]')
      .forEach(a => { if (a !== link) delete a.dataset.openedOnce; });

    // נסמן שנלחץ פעם אחת
    link.dataset.openedOnce = '1';
    return;
  }

  // לחיצה שנייה — לנווט לעמוד הקטגוריה
  delete link.dataset.openedOnce;
  window.location.href = link.href;
}, true);





document.addEventListener('click', function(e) {

  const parentItem = e.target.closest('li.parent-level.parent.has-dropdown');
  if (!parentItem) return;

  // Only on mobile menu
  // הבדיקה שלמטה לא סיננה כלום: .responsiveMenu הוא אותו <ul> גם בדסקטופ,
  // ולכן כל קליק על פריט אב בתפריט בוטל גם במסך רחב והקטגוריה לא נפתחה.
  // מוסיפים את אותו שומר רוחב שכבר קיים ב-handler שלמעלה.
  if (window.innerWidth > 1024) return;
  if (!document.querySelector('.responsiveMenu')) return;

  // If clicked the text (a.parent) but NOT the plus icon
  if (e.target.closest('a.parent') && !e.target.closest('.icon')) {
      e.preventDefault();
      parentItem.classList.toggle('open'); // ✅ ← התבנית משתמשת במחלקה הזו
  }

});


/* ההדר הדביק בנייד היה 107px בכל עומק גלילה. אין ב-CSS דרך
   לזהות שאלמנט sticky "נתקע", לכן מסמנים את מצב הגלילה על <html>
   והכיווץ עצמו נעשה ב-header-contact.css. */
(function () {
  var THRESHOLD = 120;
  var root = document.documentElement;
  var ticking = false;
  function apply() {
    root.classList.toggle('is-scrolled', (window.scrollY || window.pageYOffset) > THRESHOLD);
    ticking = false;
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(apply);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  apply();
})();


document.addEventListener('DOMContentLoaded', () => {
  const rotators = document.querySelectorAll('.announcement-rotator');
  if (!rotators.length) return;

  rotators.forEach((el) => {
    let messages;
    try {
      messages = JSON.parse(el.getAttribute('data-messages') || '[]');
    } catch (e) {
      messages = [];
    }
    if (!Array.isArray(messages) || messages.length < 2) return;

    const interval = parseInt(el.getAttribute('data-interval') || '3200', 10); // ms
    const slideMs  = parseInt(el.getAttribute('data-slide') || '280', 10);     // ms

    let i = 0;
    let timer;

   // container (full width, no horizontal scroll)
el.style.display = 'flex';
el.style.width = '100%';
el.style.maxWidth = '100%';
el.style.overflow = 'hidden';


    // inner text span
    el.innerHTML = `<span class="ar-text"></span>`;
    const textEl = el.querySelector('.ar-text');

    textEl.style.display = 'inline-block';
    textEl.style.willChange = 'transform';
    textEl.style.transform = 'translateX(0)';
    textEl.style.transition = `transform ${slideMs}ms ease`;

    textEl.textContent = messages[0];

    // RTL: slide out to the RIGHT, next comes from LEFT
    const tick = () => {
      // slide out (to right)
      textEl.style.transform = 'translateX(120%)';

      setTimeout(() => {
        i = (i + 1) % messages.length;

        // jump to left (offscreen) without transition
        textEl.style.transition = 'none';
        textEl.style.transform = 'translateX(-120%)';
        textEl.textContent = messages[i];

        // animate into center
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            textEl.style.transition = `transform ${slideMs}ms ease`;
            textEl.style.transform = 'translateX(0)';
          });
        });
      }, slideMs);
    };

    const start = () => { timer = setInterval(tick, interval); };
    const stop  = () => { if (timer) clearInterval(timer); };

    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);

    start();
  });
});

